import { BudgetClient } from '@frontend/budget/api';
import { EntityType } from '@frontend/common';
import { useResolver } from '@frontend/repository';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

declare global {
    interface WindowEventMap {
        'useBudget:request': CustomEvent<string>;
    }
}

const REQUEST_BUDGET_EVENT = 'useBudget:request';
const STORAGE_KEY = 'BUD_REQ';

export function budgetRequest(budgetId: string): string {
    window.dispatchEvent(new CustomEvent(REQUEST_BUDGET_EVENT, { detail: budgetId }));
    return STORAGE_KEY + '_loading';
}

interface Props {
    dispatch: ThunkDispatch<any, any, Action>;
}

export function BudgetResolver(props: Props) {
    useResolver(STORAGE_KEY, REQUEST_BUDGET_EVENT, EntityType.BUDGET, (ids) => BudgetClient.resolveBudgets(ids), props.dispatch);
    return <></>;
}
